const steps = [
  { number: "01", icon: "ri-global-line", title: "Order Online", description: "Start your Jackson passport application at fastpassportcenter.com in minutes. Choose your service type and processing speed." },
  { number: "02", icon: "ri-file-list-3-line", title: "Gather Documents", description: "We send you a personalized checklist of exactly what to include — citizenship proof, ID, photos, fees — no guesswork." },
  { number: "03", icon: "ri-send-plane-line", title: "Ship Documents", description: "Overnight your documents to us via FedEx or UPS from Jackson Hole. We provide the prepaid label in many cases." },
  { number: "04", icon: "ri-government-line", title: "We Submit for You", description: "Our agents submit via reserved courier slots at U.S. passport agencies — no appointment required on your end." },
  { number: "05", icon: "ri-home-4-line", title: "Delivered to You", description: "Your new passport is shipped directly back to your Jackson address via overnight carrier with full tracking." },
];

export default function HowItWorksSection() {
  return (
    <section id="how-it-works" className="bg-[#1A365D] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Simple Process</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-white mb-4">
            How Our Expedited Process Works
          </h2>
          <p className="text-white/60 max-w-xl mx-auto text-base">
            Jackson Hole residents can start online, ship documents, and receive their passport without visiting a government office. Here&apos;s exactly how it works.
          </p>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-10 left-0 right-0 h-px bg-[#F6C344]/20 mx-24"></div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
            {steps.map((step, i) => (
              <div key={i} className="relative flex flex-col items-center text-center">
                <div className="relative z-10 w-20 h-20 flex items-center justify-center rounded-full bg-[#F6C344] mb-5 flex-shrink-0">
                  <div className="flex flex-col items-center">
                    <i className={`${step.icon} text-[#1A365D] text-xl`}></i>
                    <span className="text-[#1A365D] text-xs font-bold leading-none mt-0.5">{step.number}</span>
                  </div>
                </div>
                <h3 className="font-bold text-white text-sm mb-2 leading-snug">{step.title}</h3>
                <p className="text-white/50 text-xs leading-relaxed">{step.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 text-center">
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-10 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap"
          >
            Start My Expedited Passport <i className="ri-arrow-right-line"></i>
          </a>
          <p className="text-white/40 text-xs mt-4">
            Most Jackson travelers start online and ship documents overnight — no office visit required for most services.
          </p>
        </div>
      </div>
    </section>
  );
}